/**
@flow strict-local
@format
*/

import TextStatement from './TextStatement';

export default TextStatement;
